import React, { useEffect, useState } from "react";
import "./style.css";
import heroImg from "../assets/images/heroimg.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaCircleExclamation } from "react-icons/fa6";
import { FiChevronDown } from "react-icons/fi";
import CreateCompanyFooter from "../components/createcompanyfooter/CreateCompanyFooter";
import LinkNavbar from "../components/linksnavbar/LinkNavbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { getApiBaseUrl } from "../apiBaseUrlFinder";
import aiReviewImg from "../assets/images/ai_img.png";
import gifloading from "../assets/images/rmm_loading.gif";
import { useDispatch, useSelector } from "react-redux";
import { openSignUp } from "../features/modals/modalSlice";

const ratingColors = ["#FF7575", "#FFAA5B", "#F0FE53", "#6CFF28", "#2DC932"];
const positiveTags = [
  "Growth",
  "Clear Communication",
  "Organized",
  "Supportive Leader",
  "Motivational",
  "WLB",
  "Trustworthy",
  "Fair Decision Maker",
  "Strong Mentor",
  "Recognized Effort", // Updated from "Recognizes Effort"
  "Flexible",
  "Data-Driven", // Updated from "Data-driven"
  "Hands-Off Management",
  "Approachable",
];

const negativeTags = [
  "Micromanager",
  "Resistant to Change",
  "Poor Communicator",
  "Plays Favorites",
  "Unorganized",
  "Lacks Feedback",
  "Unapproachable",
  "Overworks Team",
  "Blames Team",
  "Lack of Vision",
  "Deadline-Driven",
  "Inconsistent",
];

const ReviewSchema = Yup.object().shape({
  rating: Yup.number().required("Rating is required"),
  selectedPositiveTags: Yup.array().max(3, "Select up to 3 tags"),
  selectedNegativeTags: Yup.array().max(3, "Select up to 3 tags"),
  reviewText: Yup.string()
    .max(350, "Maximum 350 characters allowed")
    .required("Review Text is required"),
});

const ManagerReview = () => {
  const [selectedRating, setSelectedRating] = useState(0);
  const [selectedPositiveTags, setSelectedPositiveTags] = useState([]);
  const [selectedNegativeTags, setSelectedNegativeTags] = useState([]);

  const handleTagSelection = (tag, type, setFieldValue) => {
    const newPositiveTags = [...selectedPositiveTags];
    const newNegativeTags = [...selectedNegativeTags];

    const isPositive = type === "positive";
    const selectedTags = isPositive ? newPositiveTags : newNegativeTags;
    const isSelected = selectedTags.includes(tag);

    if (isSelected) {
      // Remove the tag from the respective array
      const updatedTags = selectedTags.filter((t) => t !== tag);
      if (isPositive) {
        setSelectedPositiveTags(updatedTags);
        setFieldValue("selectedPositiveTags", updatedTags);
      } else {
        setSelectedNegativeTags(updatedTags);
        setFieldValue("selectedNegativeTags", updatedTags);
      }
    } else {
      const totalSelected = newPositiveTags.length + newNegativeTags.length;
      if (totalSelected < 3) {
        selectedTags.push(tag);
        if (isPositive) {
          setSelectedPositiveTags(selectedTags);
          setFieldValue("selectedPositiveTags", selectedTags);
        } else {
          setSelectedNegativeTags(selectedTags);
          setFieldValue("selectedNegativeTags", selectedTags);
        }
      }
    }
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extract query parameters
  const managerName = queryParams.get("name");
  const managerId = queryParams.get("id");

  // Store manager profile data
  const [managerData, setManagerData] = useState(null);

  // Function to fetch manager profile
  const fetchManagerProfile = async (id, name) => {
    if (!id || !name) return;

    const apiUrl = `${getApiBaseUrl()}/manager_profile?manager_id=${encodeURIComponent(
      id
    )}&manager_full_name=${encodeURIComponent(name)}`;

    try {
      const response = await fetch(apiUrl);
      const data = await response.json();

      setManagerData(data); // Store full response in state
    } catch (error) {
      console.error("Error fetching manager profile:", error);
    }
  };

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  // Fetch manager profile when component mounts
  useEffect(() => {
    if (managerId && managerName) {
      fetchManagerProfile(managerId, managerName);
    }
  }, [managerId, managerName]);
  const navigate = useNavigate();
  const [submittedManager, setSubmittedManager] = useState(null);

  const [aiReviewText, setAiReviewText] = useState("");
  const [selectedReview, setSelectedReview] = useState("user");
  const [loadingAIReview, setLoadingAIReview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const finalReview =
      selectedReview === "ai" ? aiReviewText : values.reviewText;

    const utm_source = localStorage.getItem("utm_source") || "direct";

    const payload = {
      manager_full_name: managerData.manager_full_name,
      manager_id: managerData.manager_id,
      review_rating: values.rating,
      review: finalReview,
      positive_tags: values.selectedPositiveTags,
      negative_tags: values.selectedNegativeTags,
      ai_rewritten: !!aiReviewText,
      utm_source,
    };

    setLoading(true);
    setSubmitError(""); // Reset any previous error

    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(`${getApiBaseUrl()}/review_manager`, {
        method: "POST",
        headers,
        // headers: {
        //     "Content-Type": "application/json",
        // },
        body: JSON.stringify(payload),
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        throw new Error("Invalid JSON response from server.");
      }

      if (!response.ok) {
        const errorMessage =
          data?.error?.message ||
          data?.message ||
          `Request failed with status ${response.status}`;
        setSubmitError(errorMessage); // Set error state here
        return;
      }

      // Success flow
      setSubmittedManager(data.review_profile);
      setShow(true);
      resetForm();
      setSelectedRating("");
      setSelectedPositiveTags([]);
      setSelectedNegativeTags([]);
      setSelectedReview("");
      setAiReviewText("");
    } catch (error) {
      console.error("Error submitting review:", error);
      setSubmitError(error.message || "Unknown error"); // Capture unexpected errors
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  const handleGoTOProfile = () => {
    if (submittedManager) {
      navigate(
        `/manager?name=${encodeURIComponent(
          submittedManager.manager_full_name
        )}&id=${submittedManager.manager_id}`
      );
    }
  };
  console.log(loading);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  console.log(user);
  useEffect(() => {
    if (!user?.user_id) {
      dispatch(openSignUp());
    }
  }, [dispatch, user]);
  return (
    <>
      {loading === true ? (
        <div className="gif-banner-wrapper">
          <div className="gif-overlay"></div>
          <img src={gifloading} alt="Top Banner GIF" className="gif-banner" />
        </div>
      ) : (
        ""
      )}
      <div>
        {/* <LinkNavbar/> */}
        <div className="container">
          <div className="row">
            <div className="col-12 pt-2">
              <div className="d-flex pt-3">
                <div className="add_review_border">
                  <div className="d-flex align-items-end">
                    <h6 className="add_review_rate_h3">Rate</h6>
                    <h3 className="add_review_name_h3 ps-2 pe-5 mb-1">
                      {managerData?.manager_full_name}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="pt-1">
                <p className="manager_company_p">
                  {managerData?.manager_position} <br /> at{" "}
                  {managerData?.company_name}{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <Formik
              initialValues={{
                rating: 0,
                selectedPositiveTags: [],
                selectedNegativeTags: [],
                reviewText: "",
              }}
              validationSchema={ReviewSchema}
              onSubmit={handleSubmit}
            >
              {({ values, setFieldValue }) => (
                <Form className="container mt-4">
                  {/* Rating Bar */}
                  <div className="row mb-4">
                    <div className="col-lg-8 col-md-12 col-12">
                      <div className="review_submission_box">
                        <div className="px-lg-4 px-md-3 px-3">
                          <h4 className="rate_managers_review_h4 pt-4 pb-4">
                            Rate your manager
                          </h4>
                          <div className="px-lg-5 px-md-4 px-3 mx-lg-5">
                            <div className="d-flex pb-2 px-lg-5 px-md-4 px-3">
                              {ratingColors.map((color, index) => (
                                <div
                                  key={index}
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "-webkit-fill-available",
                                    height: "40px",
                                    backgroundColor:
                                      selectedRating >= index + 1
                                        ? color
                                        : "#d3d3d3",
                                    cursor: "pointer",
                                    borderTopRightRadius:
                                      index === 4 ? "5px" : "0",
                                    borderBottomRightRadius:
                                      index === 4 ? "5px" : "0",
                                  }}
                                  onClick={() => {
                                    setSelectedRating(index + 1);
                                    setFieldValue("rating", index + 1);
                                  }}
                                >
                                  <span className="review_submission_tag_p">
                                    {index + 1}
                                  </span>
                                </div>
                              ))}
                            </div>
                            <ErrorMessage
                              name="rating"
                              component="p"
                              className="text-danger mt-1"
                            />

                            <div className="d-flex justify-content-between pb-2">
                              <p className="review_submission_tag_p">
                                1. Awful
                              </p>
                              <p className="review_submission_tag_p">
                                5. Amazing
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Positive & Negative Tags */}
                  <div className="row mb-4">
                    <div className="col-lg-8 col-md-12 col-12">
                      <div className="review_submission_box">
                        <div className="px-lg-4 px-md-3 px-3">
                          <h4 className="rate_managers_review_h4 pt-4 pb-4">
                            Select up to 3 tags
                          </h4>
                          <div className="row">
                            <div className="col-6">
                              <p className="positive_class_p">Positive</p>
                            </div>
                            <div className="col-6">
                              <p className="positive_class_p">Negative</p>
                            </div>
                          </div>
                          <div className="row mb-4">
                            <div className="col-lg-6 d-flex flex-wrap gap-2 border_center_grey">
                              {positiveTags.map((tag) => (
                                <div
                                  key={tag}
                                  className="px-3 py-1"
                                  style={{
                                    backgroundColor: "#EDFDED",
                                    color: selectedPositiveTags.includes(tag)
                                      ? "darkgreen"
                                      : "white",
                                    cursor: "pointer",
                                    borderRadius: "30px",
                                    fontSize: "0.85em",
                                    color: "#2C2C2C",
                                    height: "28px",
                                    border: selectedPositiveTags.includes(tag)
                                      ? "2px solid darkgreen"
                                      : "",
                                  }}
                                  onClick={() =>
                                    handleTagSelection(
                                      tag,
                                      "positive",
                                      setFieldValue
                                    )
                                  }
                                >
                                  {tag}
                                </div>
                              ))}
                            </div>
                            <div className="col-lg-6 d-flex flex-wrap gap-2 pt-lg-0 pt-md-3 pt-3">
                              {negativeTags.map((tag) => (
                                <div
                                  key={tag}
                                  className="px-3 py-1"
                                  style={{
                                    backgroundColor: "#FFD0CA",
                                    color: selectedNegativeTags.includes(tag)
                                      ? "darkred"
                                      : "white",
                                    cursor: "pointer",
                                    borderRadius: "30px",
                                    fontSize: "0.85em",
                                    color: "#2C2C2C",
                                    height: "28px",
                                    border: selectedNegativeTags.includes(tag)
                                      ? "2px solid darkred"
                                      : "",
                                  }}
                                  onClick={() =>
                                    handleTagSelection(
                                      tag,
                                      "negative",
                                      setFieldValue
                                    )
                                  }
                                >
                                  {tag}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Review Textarea */}
                  <div className="row mb-4">
                    <div className="col-lg-8 col-md-12 col-12">
                      <div className="review_submission_box">
                        <div className="px-lg-4 px-md-3 px-3">
                          <h4 className="rate_managers_review_h4 pt-4">
                            Write a Review
                          </h4>
                          <p className="discuss_manager_p">
                            Discuss your manager’s strong points and areas of
                            improvement
                          </p>
                          <div className="mb-3">
                            <div className="guidelines_box py-3 px-4">
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="guidelines_p_text d-flex align-items-center">
                                  <FaCircleExclamation
                                    fontSize={18}
                                    className="me-1"
                                  />
                                  Guidelines
                                </p>
                                <p>
                                  <FiChevronDown className="me-1" />
                                </p>
                              </div>
                              <div>
                                <ul className="mb-0">
                                  <li className="list_guidelines_li">
                                    Your rating could be removed if you use
                                    profanity or derogatory terms.
                                  </li>
                                  {/*<li className="list_guidelines_li">*/}
                                  {/*  Don't claim that the manager shows bias or*/}
                                  {/*  favoritism for or against employees.*/}
                                  {/*</li>*/}
                                  <li className="list_guidelines_li">
                                    Don’t forget to proof read!
                                  </li>
                                  <Link
                                    className="view_all_guidelines_li pt-4"
                                    to="/legal-guidelines"
                                  >
                                    View All Guidelines
                                  </Link>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <Field
                            as="textarea"
                            name="reviewText"
                            className="form-control textarea_input_field"
                            rows="6"
                            maxLength={350}
                            placeholder="Share your experience working with this manager!"
                            onClick={() => setSelectedReview("user")}
                            style={{
                              backgroundColor:
                                selectedReview === "user"
                                  ? "#FAE1FB80"
                                  : "#fff",
                              border:
                                selectedReview === "user"
                                  ? "2px solid #000000"
                                  : "1px solid #ced4da",
                              transition: "all 0.2s ease",
                            }}
                          />
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <div
                              title={
                                values.reviewText.length <= 30
                                  ? "Need minimum 30 characters to use AI Enhance"
                                  : ""
                              }
                              style={{ display: "inline-block" }}
                            >
                              <button
                                type="button"
                                className="btn_manager_review_ai"
                                disabled={
                                  values.reviewText.length <= 30 ||
                                  loadingAIReview
                                }
                                onClick={async () => {
                                  try {
                                    setLoadingAIReview(true);
                                    const response = await fetch(
                                      `${getApiBaseUrl()}/review_rewrite`,
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          review: values.reviewText,
                                        }),
                                      }
                                    );
                                    const data = await response.json();
                                    if (data.review_profile) {
                                      setAiReviewText(data.review_profile);
                                      setSelectedReview("ai");
                                    }
                                  } catch (error) {
                                    console.error("AI Review Error", error);
                                    alert("Error:", error);
                                  } finally {
                                    setLoadingAIReview(false);
                                  }
                                }}
                              >
                                {loadingAIReview
                                  ? "Reviewing..."
                                  : "AI Enhance"}{" "}
                                <img
                                  src={aiReviewImg}
                                  style={{ width: "25px" }}
                                  className="ms-1"
                                ></img>
                              </button>
                            </div>
                            <small className="text-muted">
                              {values.reviewText.length}/350
                            </small>
                          </div>

                          {aiReviewText && (
                            <div className="mt-4">
                              <label>
                                <strong>AI Suggested Review:</strong>
                              </label>
                              <textarea
                                className="form-control textarea_input_field mb-lg-5 mb-md-4 mb-3"
                                rows="4"
                                value={aiReviewText}
                                onClick={() => setSelectedReview("ai")}
                                readOnly
                                style={{
                                  border:
                                    selectedReview === "ai"
                                      ? "2px solid #000000"
                                      : "1px solid #000",
                                  backgroundColor:
                                    selectedReview === "ai"
                                      ? "#FAE1FB80"
                                      : "#fff",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Submit Button */}
                  <div className="row">
                    <div className="col-lg-8 col-md-12 col-12">
                      <div className="review_submission_box mb-5">
                        <div className="d-flex justify-content-center py-lg-5 py-md-4 py-3">
                          <div>
                            <p className="submit_text_review px-lg-5 px-md-5 px-3">
                              By clicking the "Submit" button, I acknowledge
                              that I have read and agreed to the Rate My
                              Manager Site Guidelines, Terms of Use and Privacy
                              Policy. Submitted data becomes the property of
                              Rate My Manager.
                            </p>
                            <div className="d-flex justify-content-center">
                              <button
                                type="submit"
                                className="btn submit_manager_review mt-2"
                              >
                                Submit
                              </button>
                            </div>
                            <div>
                              {submitError && (
                                <div className="d-flex justify-content-center">
                                  <p
                                    style={{
                                      color: "red",
                                      marginTop: "8px",
                                      fontSize: "0.85em",
                                    }}
                                  >
                                    Error: {submitError}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          {/* Bootstrap Modal */}
          <Modal
            show={show}
            onHide={handleClose}
            centered
            dialogClassName="custom-modal"
          >
            <Modal.Body className="custom-modal-body">
              <div className="modal-content-wrapper">
                <h2 className="modal-title">✨ Review Submitted! ✨</h2>
                <p className="modal-text">
                  🚀 Thank you! Your review has been successfully submitted. You
                  can now view it on the manager's profile page.
                </p>
                <Button
                  variant="light"
                  className="close-button"
                  onClick={handleGoTOProfile}
                  style={{
                    width: "90%",
                    padding: "10px",
                    height: "auto",
                  }}
                >
                  Go to Manager Profile
                </Button>

                {/* Large screens only */}
                  <a
                    href="https://buymeacoffee.com/ratemymanager"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-none d-lg-block"
                    style={{ marginTop: "16px" }}
                  >
                    <img
                      src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                      alt="Buy Me a Coffee"
                      className="buy-me-img"
                      style={{ height: "32px", width: "auto" }}
                    />
                  </a>

                  {/* Small screens only */}
                  <a
                    href="https://buymeacoffee.com/ratemymanager"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-block d-lg-none"
                    style={{ marginTop: "16px" }}
                  >
                    <img
                      src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                      alt="Buy Me a Coffee"
                      className="buy-me-img"
                      style={{ height: "32px", width: "auto" }}
                    />
                  </a>


                {/*/!* Buy Me a Coffee (Large Screen) *!/*/}
                {/*<a*/}
                {/*  href="https://buymeacoffee.com/ratemymanager"*/}
                {/*  target="_blank"*/}
                {/*  rel="noopener noreferrer"*/}
                {/*  className="ms-2 d-none d-lg-block"*/}
                {/*  style={{ marginTop: "16px" }}*/}
                {/*>*/}
                {/*  <img*/}
                {/*    src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"*/}
                {/*    alt="Buy Me a Coffee"*/}
                {/*    className="buy-me-img"*/}
                {/*    style={{ height: "28px", width: "auto" }}*/}
                {/*  />*/}
                {/*</a>*/}
              </div>
            </Modal.Body>
          </Modal>
        </div>
        <CreateCompanyFooter />
      </div>
    </>
  );
};

export default ManagerReview;
